"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getProductReviews, Review } from "@/services/api/product";
import Skeleton from "@/components/ui/skeleton";
import { Star } from "lucide-react";
export default function TestimonialsSection() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["productReviews"],
      queryFn: getProductReviews
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t0);
  if (isLoading) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-9 w-64 mx-auto mb-6" rounded="md" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex flex-col items-center gap-2 mb-16"><div className="flex gap-1">{[...Array(5)].map(_temp)}</div><Skeleton className="h-4 w-48 mx-auto" rounded="md" /></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex gap-6 overflow-x-auto no-scrollbar pb-8">{[...Array(3)].map(_temp3)}</div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
      t4 = <section className="py-24 px-6 bg-v2-surface-container-lowest border-t border-v2-outline-variant/10"><div className="max-w-4xl mx-auto text-center">{t1}{t2}{t3}</div></section>;
      $[4] = t2;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (isError) {
    return null;
  }
  let t1;
  if ($[7] !== data?.results) {
    t1 = data?.results || [];
    $[7] = data?.results;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const reviews = t1;
  if (reviews.length === 0) {
    return null;
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h3 className="font-lora font-medium text-2xl md:text-4xl text-v2-primary mb-6">Real People. <span className="block md:inline">Real Reactions.</span></h3>;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== reviews) {
    t3 = reviews.map(_temp5);
    $[10] = reviews;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <section className="py-16 px-6 bg-[#fbf9f8] border-t border-v2-outline-variant/10"><div className="max-w-4xl mx-auto text-center">{t2}<div className="flex gap-6 overflow-x-auto no-scrollbar pb-8">{t3}</div></div></section>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp5(reviewItem) {
  return <div key={reviewItem.id} className="min-w-[280px] max-w-[320px] md:min-w-[320px] md:max-w-[320px] flex-shrink-0 bg-v2-surface-container-lowest py-8 px-5 rounded-2xl border border-v2-outline-variant/30 shadow-sm text-left whitespace-normal break-words"><div className="flex text-v2-tertiary mb-4 gap-0.5">{[...Array(5)].map(_temp4)}</div><p className="font-outfit text-[11px] sm:text-xs text-gray-500 leading-relaxed mb-6 whitespace-normal break-words">"{reviewItem.review}"</p><p className="font-label text-[10px] font-bold tracking-widest text-v2-primary uppercase">{reviewItem.customer_name}</p></div>;
}
function _temp4(__2, i_1) {
  return <Star key={i_1} className="w-4 h-4" fill="currentColor" strokeWidth={0} />;
}
function _temp3(__0, i_0) {
  return <div key={i_0} className="min-w-[280px] max-w-[280px] md:min-w-[320px] md:max-w-[320px] flex-shrink-0 bg-v2-surface-container-lowest py-8 px-5 rounded-2xl border border-v2-outline-variant/30 shadow-sm text-left flex flex-col gap-4 whitespace-normal break-words"><div className="flex gap-1 mb-4">{[...Array(5)].map(_temp2)}</div><div className="space-y-2 mb-6"><Skeleton className="h-4 w-full" rounded="sm" /><Skeleton className="h-4 w-5/6" rounded="sm" /><Skeleton className="h-4 w-4/6" rounded="sm" /></div><Skeleton className="h-3 w-16" rounded="sm" /></div>;
}
function _temp2(__1, j) {
  return <Skeleton key={j} className="w-4 h-4" rounded="full" />;
}
function _temp(_, i) {
  return <Skeleton key={i} className="w-5 h-5" rounded="full" />;
}